import axios from "axios";
import { buildAxiosAuthenticationHeaders } from "../util/build-axios-authentication-headers";
import { querytimescaleUrlEnvVar } from "@src/cloud-connect/feature-toggles/feature-toggles";
import { parseAxiosApiError } from "@src/cloud-connect/utils/parse-axios-api-error";

export interface TimeseriesParams {
  namespace: string;
  group: string;
  source: string;

  // query params
  days?: number;
  from?: string;
  to?: string;
  frequency?:
    | "raw"
    | "quarterhourly"
    | "hourly"
    | "daily"
    | "weekly"
    | "monthly"
    | "yearly";
  sortorder?: "ASC" | "DESC";
  limit?: number;
  limit_order?: "ASC" | "DESC";
  show_missing?: boolean;
}

export const getQueryTimeseriesForNodeAPI = async ({
  namespace,
  group,
  source,
  days,
  from,
  to,
  frequency,
  sortorder,
  limit,
  limit_order,
  show_missing,
}: TimeseriesParams) => {
  const url = querytimescaleUrlEnvVar();
  const headers = buildAxiosAuthenticationHeaders();

  try {
    const response = await axios.get(
      `${url}/api/v3/tsdata/ns/${namespace}/group/${group}/source/${source}`,
      {
        headers,
        params: {
          days,
          from,
          to,
          frequency,
          sortorder,
          limit,
          limit_order,
          show_missing,
        },
      },
    );

    return {
      success: true,
      data: response.data,
    };
  } catch (error) {
    const { message, status } = parseAxiosApiError(
      error,
      "Failed to fetch latest timeseries data",
    );

    return {
      success: false,
      error: message,
      status,
    };
  }
};
